import { default as OrderList } from './OrderList';
import { default as RewardItem } from './RewardItem';
import { default as ProductItem } from './ProductItem';
import { default as ProductReward } from './ProductReward';

const EXPORT = { OrderList, RewardItem, ProductItem, ProductReward };

export default EXPORT;
